import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Box,
  Users,
  ShoppingCart,
  Package,
  BarChart3,
} from "lucide-react";

export default function Sidebar({ isOpen }) {
  const menu = [
    { name: "Dashboard", path: "/", icon: LayoutDashboard },
    { name: "Products", path: "/products", icon: Box },
    { name: "Customers", path: "/customers", icon: Users },
    { name: "Sales", path: "/sales", icon: ShoppingCart },
    { name: "Inventory", path: "/inventory", icon: Package },
    { name: "Reports", path: "/reports", icon: BarChart3 },
  ];

  return (
    <div
      className={`bg-blue-700 text-white transition-all duration-300 
      ${isOpen ? "w-64" : "w-20"} 
      min-h-screen p-5`}
    >
      <h1 className="text-2xl font-bold mb-8">
        {isOpen ? "Nutsbee ERP" : "N"}
      </h1>

      <ul className="space-y-3">
        {menu.map((item, index) => {
          const Icon = item.icon;
          return (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center ${
                    isOpen ? "gap-3" : "justify-center"
                  } p-2 rounded-lg ${
                    isActive ? "bg-blue-900" : "hover:bg-blue-600"
                  }`
                }
              >
                <Icon size={20} />
                {isOpen && <span>{item.name}</span>}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
}